 class Gallery {
   constructor() {
       this.init();
   }
   init() {
       console.log('[ Gallery ] init');

       this.jsGalleryTabs();
   }
   jsGalleryTabs() {
     $('.js-gallery-tabs__item').click(function() {
       $('.js-gallery-tabs__item').removeClass('gallery-tabs__item--active');
       $(this).addClass('gallery-tabs__item--active');
       $('.js-gallery-slider').removeClass('gallery-slider--active');
       $('.js-gallery-slider[data-gallery='+$(this).data('gallery')+']').addClass('gallery-slider--active');
     })
   }
}

export {
  Gallery
};
